import styled, { css } from 'styled-components';
const DatePickerWrapper = styled.div `
  ${({ theme: { colors, space, media, fontStyles, fonts }, errorMessage, }) => css `
    .CalendarDay__selected_span {
      background: ${colors['slate-1']};
      color: ${colors.white};
      border: 1px solid ${colors['slate-5']};

      svg path {
        fill: ${colors.white} !important;
      }
    }

    .CalendarDay {
      vertical-align: middle;
    }

    .CalendarDay__selected:hover {
      background: ${colors.cda};
      color: ${colors.white};

      svg path {
        fill: ${colors.white} !important;
      }
    }

    .CalendarDay__hovered_span:hover,
    .CalendarDay__hovered_span {
      background: ${colors['patina-2']};
    }

    .DateInput_input {
      line-height: normal;
      font-size: 14px;
      color: ${colors['slate-5']};
      border-bottom: 0 !important;
      background-color: transparent;
      padding: 9px ${space.xs}; // Perfectly centers text in IE11
      height: 45px;
      box-sizing: border-box;

      ${media.up('lg')} {
        height: 32px;
        box-sizing: border-box;
      }
    }

    .DateInput_input::placeholder {
      font-style: ${fontStyles.italic};
      font-family: ${fonts.italic};
      color: ${colors['slate-4']};
      font-size: 14px;
    }

    .SingleDatePickerInput {
      display: flex;
      align-items: center;
      ${errorMessage ? `border: 1px solid ${colors.error};` : ''}
    }

    .SingleDatePickerInput__withBorder {
      border: 1px solid ${colors['slate-3']};
      border-radius: 0;
      ${errorMessage ? `border: 1px solid ${colors.error};` : ''}
    }

    .CalendarDay__default {
      border: 1px solid ${colors['slate-1']};
      color: ${colors.bluesuedeshoes};

      svg path {
        fill: ${colors['slate-4']};
      }
    }

    .CalendarDay__default:hover {
      border: 1px solid ${colors['slate-1']};
      color: ${colors.white};
      background-color: ${colors.external};

      svg path {
        fill: ${colors.white} !important;
      }
    }

    .DateInput {
      width: 100%;
      background-color: transparent;
    }

    .CalendarDay__selected {
      background-color: ${colors.external};
      color: ${colors.white};

      svg path {
        fill: ${colors.white} !important;
      }
    }

    .DayPickerKeyboardShortcuts_show__bottomRight {
      border-right: 33px solid ${colors.plum};
    }
    .DayPickerKeyboardShortcuts_show__bottomRight:hover {
      border-right: 33px solid ${colors.plum};
    }

    .SingleDatePickerInput_calendarIcon {
      margin: 0 ${space.xs};
      padding: 0;
    }

    .SingleDatePickerInput_calendarIcon_svg {
      fill: ${colors.bluesuedeshoes};
      height: ${space.lg};
      box-sizing: border-box;
      width: 19px;
    }

    .CalendarDay__blocked_out_of_range,
    .CalendarDay__blocked_calendar {
      color: ${colors['slate-2']};
    }

    .DayPickerNavigation_button {
      border: none;
      margin-top: ${space.xxs};
      background: inherit;
    }

    .DayPickerNavigation {
      display: flex;
      .DayPickerNavigation_button {
        border-radius: 3px;
        padding: 6px 9px;
        top: ${space.xs};
        position: absolute;
        right: 22px;
      }
      .DayPickerNavigation_button:first-of-type {
        left: 22px;
      }
    }

    .DayPicker_weekHeader_li {
      font-size: 14px;
      text-transform: uppercase;
      font-weight: 700;
      color: ${colors['slate-5']};
    }

    .DateInput_fang {
      top: 43px !important;
    }

    .SingleDatePicker {
      font-family: ${fonts.regular};
      width: 100%;
    }

    .SingleDatePicker_picker {
      top: 54px !important;
    }
  `}
`;
export default DatePickerWrapper;
//# sourceMappingURL=DatePickerWrapper.js.map